<div class="header-text">{{ label }}</div>
<div class="material-icons">{{ sorticon }}</div>
<ng-template #customfilter></ng-template>
<div *ngIf="subheadervisible" style="display: flex; flex-direction: row; width: 100%">
  <ng-template #subheader></ng-template>
</div>
